// @flow
import AUTH_ROUTES from 'modules/auth/routes-map'
import { BaseService } from '../base'
import { data } from './model/store'
import {
  changePasswordFx,
  restorePasswordFx,
  resetPasswordFx,
  restorePasswordByPhoneFx,
  logInFx,
  logOutFx,
  deleteAccountFx,
  autoSignUpFx,
  signUpWithPhoneOnlyFx,
  initializeSession,
  unlinkSocial,
  signUpFx,
} from './model/events'
import type { RestoreRequest, RestoreResponse, ResetRequest, RestoreByPhoneRequest } from './types'

type ServiceStore = typeof data

/**
 * Сервис сессии.
 * Содержит данные сессии и методы для регистрации/логина/логаута/удаления аккаунта и манипуляций с паролем
 */
class SessionService<T: ServiceStore> extends BaseService<T> {
  /** Инициализировать сессию */
  initialize = initializeSession

  /**
   * Восстановление пароля
   * @return {Promise<RestoreResponse>}
   */
  restorePassword = async (values: RestoreRequest): Promise<RestoreResponse> => {
    const res = await restorePasswordFx(values)

    return res
  }

  /**
   * Восстановление пароля по номеру телефона
   */
  restorePasswordByPhone = async (values: RestoreByPhoneRequest) => {
    const res = await restorePasswordByPhoneFx(values)

    if (res.resetPasswordToken)
      window.location.href = `${AUTH_ROUTES.RESET_PASSWORD}?reset_password_token=${res.resetPasswordToken}`
  }

  /** Ресет пароля */
  resetPassword = async (values: ResetRequest) => {
    const res = await resetPasswordFx(values)

    if (res.afterSignInPath) window.location.href = res.afterSignInPath
  }

  /** Вход пользователя в учётную запись */
  logIn = logInFx

  /** Выход пользователя из учётной записи */
  logOut = logOutFx

  /** Удаление аккаунта пользователя */
  deleteAccount = deleteAccountFx

  /** Авто регистроация */
  signUp = signUpFx

  /** Авто регистроация */
  autoSignUp = autoSignUpFx

  /** Регистроация по телефону */
  signUpWithPhoneOnly = signUpWithPhoneOnlyFx

  /** Отвязать соц сеть */
  unlinkSocial = unlinkSocial

  /** Сменить пароль */
  changePassword = changePasswordFx
}

const serviceInstance = new SessionService<ServiceStore>(data)

export { serviceInstance as SessionService }
